import { useEffect, useRef, type ReactNode } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

// Mount inside the route Suspense boundary: focus only after the destination is ready.
export default function PlayRouteFocus({ children }: { children: ReactNode }) {
  const { pathname, hash } = useLocation()
  const navigation = useNavigationType()
  const previousPath = useRef(pathname)
  useEffect(() => {
    if (previousPath.current === pathname) return
    previousPath.current = pathname
    if (hash) return
    // Immersive cleanup updates the shell during layout. Wait for that committed
    // frame, otherwise its display:contents container cannot receive focus yet.
    const frame = requestAnimationFrame(() => {
      // A route-owned ready/colour dialog owns its initial focus.
      if (document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]')) return
      if (navigation !== 'POP') window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      document.getElementById('play-content')?.focus({ preventScroll: true })
    })
    return () => cancelAnimationFrame(frame)
  }, [pathname, hash, navigation])
  return children
}
